<template>
  <el-container>
    <!-- <el-header height="138px" style="background-color: #eeeeee"> -->
    <Header />
    <!-- </el-header> -->
    <el-container style="background: #F5F5F6;">
      <el-main style="padding:0">
        <Main />
      </el-main>
    </el-container>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container>
</template>

<script>
import Header from '@/layout/components/header/Header'
import Main from '@/layout/components/main/Main'
import Footer from '@/layout/components/footer/Footer'

export default {
  name: 'Index',
  components: {
    Header,
    Main,
    Footer
  }
}
</script>

<style scoped>
  .el-footer{
    background: rgb(245, 245, 246);
  }
</style>
